module.exports = __webpack_public_path__ + "assets/img/out_(2).a637338e.gif";